import React from "react";

import MobileCategory from "./MobileCategory.jsx";
import MobileSplash from "./MobileSplash.jsx";

export default function MobileIndex({
    activeMenuId = -1,
    props,
    setSecondaryMenu,
    setTertiaryMenu,
    setActiveMenu,
    setUrlPath,
    setActiveFilters,
    activeFilters,
    menuItems,
    filters,
    createAllMenuItem,
    orderBy,
    setOrderBy,
    setOrderByTypes,
    orderByTypes,
    setFooter}
) {
    
    return (
        <>
            {activeMenuId === -1
                ? (<MobileSplash
                    props={props}
                    setSecondaryMenu={setSecondaryMenu}
                    setTertiaryMenu={setTertiaryMenu}
                    setActiveMenu={setActiveMenu}
                    setUrlPath={setUrlPath}
                    activeFilters={activeFilters}
                    createAllMenuItem={createAllMenuItem}
                />)
                : (<MobileCategory
                    setSecondaryMenu={setSecondaryMenu}
                    setTertiaryMenu={setTertiaryMenu}
                    setActiveMenu={setActiveMenu}
                    setUrlPath={setUrlPath}
                    setActiveFilters={setActiveFilters}
                    activeFilters={activeFilters}
                    activeMenuId={activeMenuId}
                    menuItems={menuItems}
                    filters={filters}
                    createAllMenuItem={createAllMenuItem}
                    orderBy={orderBy}
                    setOrderBy={setOrderBy}
                    setOrderByTypes={setOrderByTypes}
                    orderByTypes={orderByTypes} />)}  
        </>
    );

}

